import React, { useEffect, useState } from "react";
import Styles from "../../styles.module.scss";
import classnames from "classnames";
import { Icon } from '@iconify/react';
import Headline5 from "../../../../components/headings/Headline5";
import devIcon from "../../../../assets/images/dev-icon.png"; 
// import mysqlIcon from "../../../../assets/images/mysql-icon.svg";
// import Combodropdown from "../../../../components/autocomplete";
// import { skills } from "../../../../utils/Skill";
// import { getDetails } from "../../services";
import { postAPI } from "../../../../api/apis";
import NotificationAlert from '../../../../components/notification';
import mixpanelData from '../../../../utils/mixpanel';
import TestModal from '../../../../modals/testModal';
import { getQuestions, updateSurveyData } from "./services";
import Questionire from "../../../../modals/Questionire";
import { REACT_APP_PROFILE } from "../../../../utils/common"
 
interface Props {

  defaultValues: {
    techStack: { experience: string; expertise: number; skill: { skillId: number; skillName: string; }; stackId: number; }[];
  }
  testSkills : {}
  loginId: string
  userData: {email: string, firstname: string, lastname: string}
  testDetails: {
    HackerEarth : {creation_datetime:string , cutoff_score:number ,duration:number , end_datetime:string , id:number , practice_test_slug: string ,
          problem_types_data :{MultipleChoiceQuestions : { total_score: number,num_problems: number} , Programming: {total_score: number, num_problems: number} , SQL: {total_score: number, num_problems: number}},
          slug: string , title: String, icon_url : string
    },
    UserInfo: {
      status: string,
      is_passed: string
    },
  }[],
  surveyStatus?: any,
  getCandidateDetails?: any
}
 
const SkillsTest: React.FC<Props> = ({
  defaultValues,
  testSkills,
  testDetails,
  loginId,
  userData,
  surveyStatus, 
  getCandidateDetails
}) => {

  const [qestions, setQuestions] = useState<any>()
  const profileMetadata = JSON.parse(localStorage.getItem("profile_metadata") || "") || {}
  const [alert, setAlert] = useState<boolean>(false)
  const [visibleTestModal, setVisibleTestModal] = useState(false);
  const [test_id, setTest_id] = useState<number>()
  const [visibleQuestionnireModal, setVisibleQuestionnireModal] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')

    // useEffect(() => {
    //   // const techStack = defaultValues.techStack ? defaultValues.techStack.map(item => {
    //   //   return ({
    //   //     name: item.skill.skillName, id: item.skill.skillId, expertise: item.expertise, experience: item.experience,
    //   //     other: CONSTANTS.Skills.filter(skill => skill.id === item.skill.skillId).length === 0
    //   //   })
    //   // }) : []
    //   // setAddedSkills(techStack)

    // }, [testDetails])
  
  useEffect(() => {
     
  
  }, [surveyStatus])
  
   
  // const getAddedSkills = () => [...CONSTANTS.Skills, ...addedSkills.filter(item => item.other)]
  // const [skillOthers, setSkillOthers] = useState<boolean>(false)


   
  // const skillChange = (e: any, skill: { name: string, id: number }) => {

  //   // delete errors.expertise
  //   // delete errors.experience
  //   // setErros({ ...errors })



  //   let updatedSkill: { name: string, id: number,other: boolean }
  //     = { ...skill, other: e === 'addValue' }


  //   if (skill !== null) {
  //     if (e.value || e === 'addValue') {
  //       addedSkills.push(updatedSkill)
  //       // delete errors.expertise
  //       // delete errors.experience
  //       // setErros({ ...errors })
  //       if (skill.name === "Others") {
  //         setSkillOthers(true)
  //       }
  //     }
  //     else {
  //       const index = addedSkills.findIndex(item => item.id === skill.id);
  //       if (index > -1) {
  //         addedSkills.splice(index, 1);
  //       }
  //       if (skill.name === "Others") {
  //         setSkillOthers(false)
  //       }
  //     }
  //   }
  //   setAddedSkills([...addedSkills])
  // }

  // const getDefaultSkills = (item: { name: string, id: number }) => addedSkills ? !!addedSkills.filter(id => id.id === item.id).length : false

  const takeTest = (item: any) => {
    let value = {
      loginId: loginId,
      email: userData.email,
      redirectionUrl: 'https://myworkplace.ellow.io/assessments',
      testId: test_id,
      candidateName: userData.firstname + ' ' + userData.lastname
    }  
    postAPI( REACT_APP_PROFILE + '/test-invite-ext', value).then((response) => {
      if ( response && response.status === 1 ){
        mixpanelData('MWP-Take Test', value)
        mixpanelData('New MWP - Take Test', {
          'Candidate loginid': loginId,
          'Email': userData.email,
          'Test id': test_id,
          'Name': userData.firstname + ' ' + userData.lastname,
          'distinct_id': userData.email
        })
        window.location.href = response.testUrl
      }else{
        setAlert(true)
        setMessage('Candidate(s) previously invited.')
        setTimeout(() => {
          setAlert(false)
        }, 4000);
      }
      if(response && response.status === 1){
        mixpanelData('MWP-Test Details Updated', {
          'source': "freelancer test details updated",
          'Success':  true,
          'distinct_id': value && value.email,
          'Name ' : value.candidateName,
          'test_id': value.testId,
          'test_name':item.HackerEarth.title,
          'Email':value.email
        })
      }
    })  

  }

  const pendingTest = (item: any) => {
    window.location.href = item.UserInfo.test_invite_url 
  }

  const testResultPublished = (item: any) => {
    setAlert(true)
    if(item.UserInfo.is_passed){
      setMessage('Hey, you made it! Our recruiters will get in touch with you soon to know your preferences so that they can get you matched to the most exciting and relevant job opportunities for you!')
    }else{
      setMessage('Hey, do not worry about failure; failures are the stepping stones for a huge success, so do not worry if you fail in the first attempt, you will have another chance to attempt the test after 3 months')
    }
    setTimeout(() => {
      setAlert(false)
    }, 5000);
  }

  const alertOnclose = () => {
    setAlert(false);
  }
  // const testModal = (item : any) => {
  //   setTest_id(item.HackerEarth.id)
  //   setVisibleTestModal(!visibleTestModal)
  // }
  const closeTestModal = () => {
    setVisibleTestModal(!visibleTestModal)
  }

  const questionModal = (item: any) => {
    
    setTest_id(item.HackerEarth.id)
    if (surveyStatus) {
      setVisibleTestModal(true)       
    }
    else {
      getQuestions().then((response) => {
        if (response && response.status === 1) {
          setQuestions(response.data)
        }
      })
      setVisibleQuestionnireModal(true)
    }
    
  }
  
  const onQuestionireSubmit = (data: any) => {  
    
    updateSurveyData(data).then((response) => {
      if (response && response.status === 1) {
        mixpanelData('New MWP - Survey submited', {
          'distinct_id': profileMetadata && profileMetadata.email,
          'Candidate email': profileMetadata && profileMetadata.email,
          'Candidate loginid': localStorage.getItem('loginId')
        })
        displayNotification("Details saved successfully")
        setVisibleTestModal(true)
        setVisibleQuestionnireModal(false)
        getCandidateDetails()
      }
    })
  }

  const displayNotification = (message: string) => {
    setMessage(message)
    setAlert(true)
    setTimeout(() => {
       setAlert(false)
     }, 4000);
  }

  return (
    <div className={Styles.skillsTest}>
      {alert && <NotificationAlert closable={true} onClose={alertOnclose}>{message}</NotificationAlert> }
      {visibleTestModal && (<TestModal onClose={closeTestModal} takeTest={takeTest} />)}
      {visibleQuestionnireModal && (<Questionire onClose={() => setVisibleQuestionnireModal(false)} questions={qestions} clickHandler={onQuestionireSubmit} />)}
      <div className={Styles.skillsList}>
      {/* <div className={Styles.tagLabelWrap}>
        {getAddedSkills().map((skill, key) => <TagLabel label={skill.name}
          key={key}
          value={skill.id}
          checked={getDefaultSkills(skill)}
          handleChange={(e: any) => skillChange(e, skill)} />)}

        {skillOthers && <div className={Styles.tagDropdown}>
          <Combodropdown
            placeholder="Please search your skill"
            data={skills}
            name='name'
            id='id'
            handleChange={(value: { name: string, id: number }) => skillChange("addValue", value)}
          />
        </div>}
      </div> */}
        {/* <TagLabel label="Python" checked={true} />
        <TagLabel label="Ruby on Rails" checked={false} />
        <TagLabel label="MySql" checked={true} />
        <TagLabel label="Angular" checked={false} />
        <TagLabel label="iOS Swift" checked={false} />
        <TagLabel label="PHP" checked={false} />
        <TagLabel label="Flutter" checked={false} />
        <TagLabel label="Golang" checked={false} />
        <TagLabel label="Machine Learning/Data Science" checked={false} />
        <TagLabel label="Data Engineering" checked={false} />
        <TagLabel label="Ruby on Rails" checked={false} />
        <TagLabel label="Android(Kotlin)" checked={false} />
        <TagLabel label="DevOps+" checked={false} />
        <TagLabel label="C# / .NET" checked={false} />
        <TagLabel label="Others" checked={false} /> */}


      </div>
      <Headline5>Tests available:</Headline5>
      <div className={Styles.testCards}>
        {testDetails && testDetails.map((item, key) => 
        <div className={item.UserInfo ? classnames(Styles.card, Styles.selected) : Styles.card } key={key}>
          {item.UserInfo && item.UserInfo.is_passed  && <Icon icon="akar-icons:circle-check"/>}
          { item.HackerEarth.icon_url ? <img src={ item.HackerEarth.icon_url} alt='icon'/> : <img src={devIcon} alt='icon'/>}
          <h3>{item.HackerEarth.title}</h3>
          <p>{Math.floor(item.HackerEarth.duration  / 60)} mins</p>
          <button onClick={() => item.UserInfo ? item.UserInfo.is_passed === null ? pendingTest(item) : testResultPublished(item) : questionModal(item) }>
            {item.UserInfo ? item.UserInfo.is_passed ? 'Passed' : item.UserInfo.is_passed !== null ? 'Failed' : 'Pending' : 'Take Test'}
          </button>
        </div>
        )}
      </div>
    </div>
  );
}
export default SkillsTest;
